import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function AccessibilityStatement() {
  return (
    <LegalLayout
      title="Accessibility Statement"
      updated="June 6, 2026"
      path="/accessibility"
      description="Travel Club Navigator Group's commitment to digital accessibility and how to reach us with feedback."
    >
      <p data-testid="accessibility-intro">
        Travel Club Navigator Group is committed to ensuring digital accessibility for people of all
        abilities. We are continually improving the user experience for everyone and applying the
        relevant accessibility standards to make our website welcoming and usable for as many people as
        possible.
      </p>

      <LegalSection heading="1. Our Commitment">
        <p>
          We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA. These
          guidelines explain how to make web content more accessible to people with a wide range of
          disabilities, including visual, auditory, physical, speech, cognitive, and neurological.
        </p>
      </LegalSection>

      <LegalSection heading="2. Measures We Take">
        <ul className="list-disc space-y-2 pl-6">
          <li>Semantic, structured HTML with descriptive headings and landmarks.</li>
          <li>Descriptive alternative text for meaningful images.</li>
          <li>Sufficient color contrast for text and interactive elements.</li>
          <li>Keyboard-navigable menus, buttons, and forms.</li>
          <li>Accessible labels on form fields and interactive controls.</li>
          <li>Responsive layouts that adapt to zoom and different screen sizes.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Ongoing Effort">
        <p>
          Accessibility is an ongoing effort. We regularly review the Site and work to remedy any issues we
          discover. Some content provided by third parties may not yet be fully accessible, and we are
          working to improve these areas over time.
        </p>
      </LegalSection>

      <LegalSection heading="4. Feedback &amp; Assistance">
        <p>
          We welcome your feedback on the accessibility of our website. If you encounter a barrier, or need
          information in an alternative format, please contact us and we will do our best to help:
        </p>
        <ul className="list-disc space-y-2 pl-6">
          <li>
            Email:{" "}
            <a href="mailto:hello@travelclubnavigator.co" className="text-primary hover:underline">
              hello@travelclubnavigator.co
            </a>
          </li>
        </ul>
        <p>
          When contacting us, please describe the issue and the page where you experienced it so we can
          respond as quickly as possible.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
